
const OPENER_MARGIN = 100;
const MAX_MAX_HEIGHT = 300;

export default function openerHeightChecker(player, $selector) {
   if (!player || !player.getElement()) return;

   $selector.style.maxHeight = '';
   const rect = player.getElement().parentNode.getBoundingClientRect();
   const mh = (rect.height || rect.bottom - rect.top) - OPENER_MARGIN;

   $selector.style.maxHeight = `${Math.min(mh, MAX_MAX_HEIGHT)}px`;
}
